import React from 'react';
import { IProps } from 'components/Card/CardHorizontal/types';
import { Link } from 'react-router-dom';
import commonService from 'utils/commonService';

const CardHorizontal: React.FC<IProps> = (props) => (
  <div className="card-horizontal">
    <div
      className="card-horizontal__cover-photo"
      style={{
        backgroundImage: `url(${props.imgUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    />
    <div className="card-horizontal__content">
      <div className="card-horizontal__title">{props.title}</div>
      <div className="card-horizontal__desc">
        {props.desc.map((content: string, index: number) => (
          <p key={index}>{content}</p>
        ))}
      </div>
      <div className="card-horizontal__highlight">
        {props.highlightContent.map((content: string, index: number) => (
          <p key={index}>{content}</p>
        ))}
      </div>
      <div className="card-horizontal__controls">
        <Link
          to={() => {
            commonService.setActiveProdId(props.INS_TYPE_ID, props.PROD_ID);
            return {
              pathname: props.btnLink,
              state: {
                insTypeId: props.INS_TYPE_ID,
                prodId: props.PROD_ID
              }
            };
          }} className="card-horizontal__btn"
        >{props.btnText}
        </Link>
      </div>
    </div>
  </div>
);

export default CardHorizontal;
